/* unplugin-vue-components disabled */import { render } from "./chat-error.vue?vue&type=template&id=037e81f6&scoped=true"
import script from "./chat-error.vue?vue&type=script&lang=js"
export * from "./chat-error.vue?vue&type=script&lang=js"

import "./chat-error.vue?vue&type=style&index=0&id=037e81f6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037e81f6"],['__file',"src/components/ai-chat-v2/chat-error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "037e81f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('037e81f6', __exports__)) {
    api.reload('037e81f6', __exports__)
  }
  
  module.hot.accept("./chat-error.vue?vue&type=template&id=037e81f6&scoped=true", () => {
    api.rerender('037e81f6', render)
  })

}


export default __exports__